import { useEffect, useState } from 'react';
import { Service } from '../api-objects/Service';
import { Configuration } from '../api-objects/Configuration';

const ConfigurationService = () => {
  const [result, setResult] = useState<Service<Configuration>>({
    status: 'loading'
  });

  useEffect(() => {
    fetch('/api/configuration.json')
      .then(response => response.json())
      .then(response => setResult({ status: 'loaded', payload: response }))
      .catch(error => setResult({ status: 'error', error }));
  }, []);

  return result;
};

export default ConfigurationService;